(function(angular, _) {
    'use strict';

    angular.module('wtApp.dataService').controller('FeatureFlagController', FeatureFlagController);

    /**
     * Used to extend the scope
     * @param {Object} $scope
     * @param {Object} $rootScope
     * @param {Object} featureFlagService
     * @constructor
     */
    function FeatureFlagController($scope, $rootScope, featureFlagService) {
        const that = this;

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.featureFlagService = featureFlagService;

        $scope.setFeatureFlags = function() {
            that.setFeatureFlags.apply(that, arguments);
        };
    }

    /**
     * Inject
     * @type {string[]}
     */
    FeatureFlagController.$inject = ['$scope', '$rootScope', 'featureFlagService'];

    /**
     * Set feature flags
     * @param {Object} config
     * @returns {FeatureFlagController}
     */
    FeatureFlagController.prototype.setFeatureFlags = function setFeatureFlags(config) {
        const that = this;

        _.forEach(config, (flagValue, flagName) => {
            that.featureFlagService.setFeatureFlag(flagName, flagValue);
        });

        _.merge(that.$rootScope.WTF, that.featureFlagService.getFeatureFlags());

        return this;
    };
})(window.angular, window._);
